<!--

    * UBCO Footer
    This is a UBCO Footer that gets its styles and scripts from the UBC CDN.
    ! DO NOT ADD ANY STYLES OR SCRIPTS, IT'S ALL HANDLED BY THE UBC CDN SCRIPT AND STYLESHEETS !

-->

<!-- Footer Area Unit Menu - Mobile Only -->
<footer id="ubc7-footer" class="expand">
    <div class="row-fluid expand" id="ubc7-unit-footer">
        <div class="container">
            <div class="span10" id="ubc7-unit-address">
                <div id="ubc7-address-unit-name">Life Cycle Management Laboratory</div>
                <div id="ubc7-address-campus">Okanagan Campus</div>
                <div id="ubc7-address-street">EME 3287-1137 Alumni Avenue</div>
                <div id="ubc7-address-location">
                    <span id="ubc7-address-city">Kelowna</span>, <span id="ubc7-address-province">BC</span> <span id="ubc7-address-country">Canada</span> <span id="ubc7-address-postal">V1V 1V7</span>
                </div>
                <div id="ubc7-address-phone">Tel 250 807 8176</div>
                <div id="ubc7-address-email">kasun.hewage@ubc.ca</div>
            </div>
            <div class="span2">
                <strong>Find UBC on</strong>
                <div id="ubc7-unit-social-icons">
                    <a href="https://www.facebook.com/universityofbc?fref=ts" target="_blank"><i class="icon-facebook-sign"></i></a>&nbsp;
                    <a href="https://instagram.com/universityofbc" target="_blank"><i class="icon-instagram-sign"></i></a>&nbsp;
                    <a href="https://twitter.com/ubc" target="_blank"><i class="icon-twitter-sign"></i></a>&nbsp;
                    <a href="https://www.linkedin.com/school/universityofbc" target="_blank"><i class="icon-linkedin-sign"></i></a>&nbsp;
                    <a href="https://www.youtube.com/user/ubc" target="_blank"><i class="icon-youtube-sign"></i></a>&nbsp;
                </div>
            </div>
        </div>
    </div>
    <div class="row-fluid expand ubc7-back-to-top">
        <div class="container">
            <div class="span2">
                <!-- svelte-ignore a11y-invalid-attribute -->
                <a href="#">Back to top <div class="ubc7-arrow up-arrow grey"></div></a>
            </div>
        </div>
    </div>
    <div class="row-fluid expand" id="ubc7-global-footer">
        <div class="container">
            <div class="span5" id="ubc7-signature"><a href="http://www.ubc.ca/">The University of British Columbia</a></div>
            <div class="span7" id="ubc7-footer-menu">
            </div>
        </div>
    </div>
    <div class="row-fluid expand" id="ubc7-minimal-footer">
        <div class="container">
            <div class="span12">
                <ul>
                    <li><a href="http://cdn.ubc.ca/clf/ref/emergency">Emergency Procedures</a> <span class="divider">|</span></li>
                    <li><a href="http://cdn.ubc.ca/clf/ref/terms">Terms of Use</a> <span class="divider">|</span></li>
                    <li><a href="http://cdn.ubc.ca/clf/ref/copyright">Copyright</a> <span class="divider">|</span></li>
                    <li><a href="http://cdn.ubc.ca/clf/ref/accessibility">Accessibility</a></li>
                </ul>
            </div>
        </div>
    </div>
</footer>
<!-- End of Footer Area Unit Menu -->